import React, { Component } from "react";
import { Layout, Icon } from "antd";

const { Content, Header } = Layout;

class HomePage extends Component {
  render() {
    return (
      <Layout style={{ marginLeft: 200 }}>
        <Header className="header">
          <h2 className="header-headline">About ELF DIGEST</h2>
        </Header>
        <Content className="page-content">
          <div className="inner-page-content">
            {/* Hero Section */}
            <div style={{
              background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
              borderRadius: 16,
              padding: '48px',
              marginBottom: 32,
              color: '#fff',
              textAlign: 'center',
            }}>
              <h1 style={{
                fontSize: 36,
                fontWeight: 700,
                margin: '0 0 16px',
                color: '#fff',
              }}>
                Linux Malware Analysis Service
              </h1>
              <p style={{
                fontSize: 18,
                opacity: 0.9,
                maxWidth: 600,
                margin: '0 auto',
                lineHeight: 1.6,
              }}>
                A non-profit service for cyber security professionals, researchers, and academics.
              </p>
            </div>

            {/* Features Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: 24,
              marginBottom: 32,
            }}>
              {/* Static Analysis */}
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  background: '#f5f3ff',
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 16,
                }}>
                  <Icon type="file-search" style={{ fontSize: 24, color: '#8b5cf6' }} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Static Analysis</h3>
                <p style={{ color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                  Searches for IoCs in strings, identifies obfuscation, string encoding, and executable packing.
                </p>
              </div>

              {/* Behavioural Analysis */}
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  background: '#ecfdf5',
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 16,
                }}>
                  <Icon type="eye" style={{ fontSize: 24, color: '#10b981' }} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Behavioural Analysis</h3>
                <p style={{ color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                  Detects VM detection, anti-debugging, persistence, process injection, and kernel module loading.
                </p>
              </div>

              {/* Network Analysis */}
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <div style={{
                  width: 48,
                  height: 48,
                  background: '#fef3c7',
                  borderRadius: 12,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: 16,
                }}>
                  <Icon type="global" style={{ fontSize: 24, color: '#f59e0b' }} />
                </div>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Network Analysis</h3>
                <p style={{ color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                  Identifies C2 endpoints, botnet type, resolved domains, HTTP requests, and exploits.
                </p>
              </div>
            </div>

            {/* Info Cards */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: 24,
              marginBottom: 32,
            }}>
              {/* Supported Architectures */}
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                  <Icon type="deployment-unit" style={{ marginRight: 12, color: '#8b5cf6' }} />
                  Supported Architectures
                </h3>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {['ARMv5', 'ARMv7', 'MIPS', 'x86', 'x86_64'].map(arch => (
                    <span key={arch} style={{
                      background: '#f1f5f9',
                      padding: '6px 12px',
                      borderRadius: 6,
                      fontSize: 13,
                      fontWeight: 500,
                      color: '#475569',
                    }}>
                      {arch}
                    </span>
                  ))}
                </div>
              </div>

              {/* Integrations */}
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              }}>
                <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16, display: 'flex', alignItems: 'center' }}>
                  <Icon type="api" style={{ marginRight: 12, color: '#8b5cf6' }} />
                  Integrations
                </h3>
                <p style={{ color: '#64748b', margin: 0, lineHeight: 1.6 }}>
                  Findings and artifacts are shared via <strong>MalwareBazaar</strong> and <strong>VirusTotal</strong> unless the 'do not share' option is selected.
                </p>
              </div>
            </div>

            {/* Registration Section */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: '32px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              marginBottom: 32,
            }}>
              <h3 style={{ fontSize: 20, fontWeight: 600, marginBottom: 16 }}>
                <Icon type="user-add" style={{ marginRight: 12, color: '#8b5cf6' }} />
                How to Register
              </h3>
              <p style={{ color: '#64748b', marginBottom: 16, lineHeight: 1.8 }}>
                Registration requests are manually approved to prevent abuse of the service.
                Please send a registration request with the following details to{' '}
                <strong style={{ color: '#8b5cf6' }}>elfdigest [at] gmail [dot] com</strong>:
              </p>
              <ul style={{
                color: '#64748b',
                lineHeight: 2,
                paddingLeft: 20,
                marginBottom: 16,
              }}>
                <li>Work/Organization email</li>
                <li>First Name & Last Name</li>
                <li>Organization/Company</li>
                <li>Role</li>
              </ul>
              <p style={{
                color: '#475569',
                background: '#f8fafc',
                padding: '12px 16px',
                borderRadius: 8,
                borderLeft: '4px solid #8b5cf6',
                margin: 0,
              }}>
                Once your registration is approved, you will be contacted by email.
              </p>
            </div>

            {/* Credits */}
            <div style={{
              textAlign: 'center',
              padding: '24px',
              color: '#64748b',
              fontSize: 14,
            }}>
              <p style={{ margin: 0 }}>
                Created by <strong>Tolijan Trajanovski</strong> (<a href="https://twitter.com/tolisec" target="_blank" rel="noopener noreferrer">@tolisec</a>)
                {' '} | Based on{' '}
                <a href="https://github.com/danieluhricek/LiSa" target="_blank" rel="noopener noreferrer">LiSa</a>
              </p>
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
}

export default HomePage;
